import type { TRPCClientError } from "@trpc/client";
import { isTRPCClientError } from "@trpc/client";
import type { InferrableClientTypes } from "@trpc/server/unstable-core-do-not-import";
import type { ErrorOption } from "react-hook-form";

interface StringiverseTRPCError<T extends InferrableClientTypes>
	extends TRPCClientError<T> {
	shape: TRPCClientError<T>["shape"] & {
		fields?: [string, string][];
		redirect?: string;
	};
}

export function isStringiverseTRPCError<T extends InferrableClientTypes>(
	error: unknown,
): error is StringiverseTRPCError<T> {
	return isTRPCClientError(error);
}

export function handleStringiverseTRPCError<
	FieldName,
	T extends InferrableClientTypes,
>(
	error: unknown | StringiverseTRPCError<T>,
	setError?: (fieldName: FieldName, error: ErrorOption) => void,
	setFormError?: (error: string) => void,
) {
	if (!isStringiverseTRPCError<T>(error) || !error.shape) {
		console.error("Unknown error:", error);
		setFormError?.(`An unknown error occurred: ${error}`);
		return;
	}

	if (error.shape.redirect) {
		window.location.href = error.shape.redirect;
		return;
	}

	setFormError?.(error.message);

	if (error.shape.fields && Array.isArray(error.shape.fields) && setError) {
		for (const [fieldName, message] of error.shape.fields as [
			string,
			string,
		][]) {
			setError(fieldName as FieldName, { message });
		}
	}
}
